import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
/**
 * Logomark "X" isolado com gradiente Aurora→Plasma.
 * Para favicon, ícone de app, marca d'água. NÃO usar como protagonismo —
 * o protagonismo é da tipografia.
 */
export function Logomark({ size = 32, className }) {
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 32 32", fill: "none", "aria-label": "AXIOMA", className: className, children: [_jsx("defs", { children: _jsxs("linearGradient", { id: "ax-mark-grad", x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [_jsx("stop", { offset: "0%", stopColor: "#FFD27A" }), _jsx("stop", { offset: "50%", stopColor: "#E5A547" }), _jsx("stop", { offset: "100%", stopColor: "#6E5BFF" })] }) }), _jsx("path", { d: "M5 5L27 27M27 5L5 27", stroke: "url(#ax-mark-grad)", strokeWidth: "3.5", strokeLinecap: "round" })] }));
}
/**
 * Wordmark AXIOMA — texto rendererizado por tipografia (Space Grotesk).
 * Use em headers, hero, materiais institucionais. Sempre prefira ao logomark
 * quando houver espaço para texto (a marca tem 70% de tipografia).
 */
export function Logotype({ size = 'md', className, }) {
    const sizeClasses = {
        sm: 'text-base tracking-tight',
        md: 'text-2xl tracking-tighter',
        lg: 'text-5xl tracking-tighter',
    };
    return (_jsxs("span", { className: cn('ax-wordmark text-ax-text-primary inline-flex items-center', sizeClasses[size], className), children: ["A", _jsx("span", { className: "ax-gradient-text", children: "X" }), "IOMA"] }));
}
//# sourceMappingURL=Logo.js.map